// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 3XKtdQt7wvDVebnmrsdFvB

import * as React from "react";
import { hasVariant, ensureGlobalVariants } from "@plasmicapp/react-web";
import { EmbedCss } from "@plasmicpkgs/plasmic-embed-css";

export interface GlobalContextsProviderProps {
  children?: React.ReactElement;
  embedCssProps?: Partial<
    Omit<React.ComponentProps<typeof EmbedCss>, "children">
  >;
}

export default function GlobalContextsProvider(
  props: GlobalContextsProviderProps
) {
  const { children, embedCssProps } = props;

  return (
    <EmbedCss
      {...embedCssProps}
      css={
        embedCssProps && "css" in embedCssProps
          ? embedCssProps.css!
          : "\n@font-face {\n  font-family: 'MT Gertrudes Medium';\n  src: url('https://site-assets.plasmic.app/204831867f3796573158e01c7317fdf1.otf');\n}\n\n@font-face {\n  font-family: 'MT Gertrudes Bold';\n  src: url('https://site-assets.plasmic.app/17df96b4b74af1b88e469b29069f6d85.otf');\n}"
      }
    >
      {children}
    </EmbedCss>
  );
}
